import React from 'react';
import TableRow from './table.row';

const TableOrder = ({ data, keys }) => {
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpander = async (e) => {
    setExpanded(!expanded);
  };

  React.useEffect(() => {
  }, []);

  React.useEffect(() => {
    if (!data) return;

    if (keys === 0) {
      setExpanded(true);
    }
  }, [data]);

  return [
    <tr onClick={toggleExpander} key={keys}>
      <td
        style={{
          whiteSpace: 'initial',
          width: '5%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
        className="px-2"
      >
        {keys + 1}
      </td>
      <td
        style={{
          whiteSpace: 'initial',
          width: '20%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
      >
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {data?.order}
          </div>
        </div>
      </td>
    </tr>,
    expanded && (
      <tr class='bg-light'>
        <td colspan='2'>
          <div class='border rounded-3 mt-3 p-1'>
            <table
            width="100%"
            className="table table-hover table-vcenter card-table datatable"
          >
            <thead className="bg-light">
              <tr className="th">
                <th style={{ whiteSpace: 'initial', width: '5%' }}>No</th>
                <th style={{ whiteSpace: 'initial', width: '20%' }}>
                  Kode
                </th>
                <th style={{ whiteSpace: 'initial', width: '30%' }}>
                  Tujuan
                </th>
                <th style={{ whiteSpace: 'initial', width: '15%' }}>
                  Tgl Diterima
                </th>
                <th style={{ whiteSpace: 'initial', width: '15%' }}>
                  Diterima oleh
                </th>
                <th style={{ whiteSpace: 'initial', width: '15%' }}>
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.shipments?.map((s, i) => (
                <TableRow data={s} key={i} keys={i} />
              ))}
            </tbody>
          </table>

          </div>

        </td>
      </tr>
    )
  ]
};

export default TableOrder;
